import GoalCategory from './GoalCategory';

export default GoalCategory;
